import React, { useState } from "react";
import { ChevronRight, ClockFill } from "react-bootstrap-icons";
import { formatTime } from "../helpers/global";
import useTimeTracker from "../hooks/useTimeTracker";
import RippleEffect from "./RippleEffect";
import { useLocation } from "react-router-dom";
import { isJobPage } from "../Util/PathUtil";

const TimerClock = ({ className }) => {
  const { activeTimeEntry, elapsedTime, openModal } = useTimeTracker();
  const [expanded, setExpanded] = useState(false);
  const location = useLocation()
  const jobPage = isJobPage(location.pathname)

  if (jobPage) {
    return null
  }

  return (
    <div
      className={`p-2 text-center align-items-center bg-primary d-flex align-items-center border border-dark  ${
        activeTimeEntry ? "text-white" : "text-white"
      } ${expanded ? "rounded-pill" : "rounded-left"}`}
      style={{
        position: "fixed",
        bottom: 80,
        right:0,
      }}
    >
      <div
        className="d-flex align-items-center hover px-1"
        onClick={expanded ? openModal : () => setExpanded(true)}
      >
        {activeTimeEntry ? (
          <RippleEffect size={20} />
        ) : (
          <ClockFill
            className={activeTimeEntry ? "text-success" : ""}
            size={20}
          />
        )}

        {expanded && (
          <>
            <h6
              style={{ width: 140 }}
              onClick={openModal}
              className="clock-text large-text mb-0 px-3 "
            >
              {activeTimeEntry ? formatTime(elapsedTime) : "Clock In"}
            </h6>
          </>
        )}
      </div>
      {expanded && (
        <>
          <ChevronRight
            size={18}
            className="hover"
            onClick={() => setExpanded(false)}
          />
        </>
      )}
    </div>
  );
};

export default TimerClock;
